import generalActionTypes from './action-types';

export const fetchRegisterFormSubmission = payload => ({
  type: generalActionTypes.FETCH_REGISTER_FORM_SUBMISSION,
  payload,
});

export const fetchRegisterFormSubmissionSuccess = payload => ({
  type: generalActionTypes.FETCH_REGISTER_FORM_SUBMISSION_SUCCESS,
  payload,
});

export const fetchRegisterFormSubmissionFail = payload => ({
  type: generalActionTypes.FETCH_REGISTER_FORM_SUBMISSION_FAIL,
  payload,
});
